function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var PeaceOfMind = function PeaceOfMind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5m3.32-2.13c.45.34 1.297.749 2.325.75H8.14h.01-.005c.709 0 1.487-.191 2.275-.72.34-.23.43-.7.2-1.04a.753.753 0 0 0-1.04-.2c-1.47 1-2.7.13-2.84.03a.748.748 0 0 0-.92 1.18m7.39 0c.44.34 1.297.749 2.325.75h-.005.01-.005c.709 0 1.487-.191 2.275-.72.34-.23.43-.7.2-1.04a.753.753 0 0 0-1.04-.2c-1.47 1-2.7.13-2.84.03a.756.756 0 0 0-1.05.13c-.25.32-.2.8.13 1.05M12 17.53c-2.34 0-4.408-1.187-4.624-1.311l-.016-.009a.76.76 0 0 1-.26-1.03c.21-.36.67-.47 1.03-.26l.008.005c.138.078 1.94 1.105 3.862 1.105s3.724-1.027 3.862-1.105l.008-.005a.74.74 0 0 1 1.03.26c.21.36.1.82-.26 1.03l-.015.008c-.212.122-2.292 1.312-4.625 1.312",
    clipRule: "evenodd"
  }));
};
export default PeaceOfMind;
PeaceOfMind.displayName = 'PeaceOfMind';